'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapUnwrapped = exports.Map = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _universalConfig = require('universal-config');

var _universalConfig2 = _interopRequireDefault(_universalConfig);

var _StudioMarkerCluster = require('./StudioMarkerCluster');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/jsx-no-undef */
/* globals Leaflet */

// We have this ^^ because the Leaflet lib cannot be loaded on the server as it
// expects `window` and `document` to be available. We inject Leaflet at build
// time in webpack.dev/prod.js.

require('../../../../node_modules/leaflet/dist/leaflet.css');

var DEFAULT_TILE_LAYER_MAX_ZOOM = 18;
var DEFAULT_TILE_LAYER_MIN_ZOOM = 8;

var MapUnwrapped = function (_Component) {
  (0, _inherits3.default)(MapUnwrapped, _Component);

  function MapUnwrapped() {
    (0, _classCallCheck3.default)(this, MapUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (MapUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(MapUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(MapUnwrapped, [{
    key: 'shouldComponentUpdate',


    // We should only rerender the map if the studios data or default location
    // passed to the component changes.
    value: function shouldComponentUpdate(props) {
      var _props = this.props,
          studiosData = _props.studiosData,
          defaultLocation = _props.defaultLocation,
          defaultBounds = _props.defaultBounds,
          children = _props.children;


      if (children !== props.children || !studiosData && props.studiosData || studiosData && !props.studiosData) {
        return true;
      } else if (studiosData && (0, _stringify2.default)(studiosData.map(function (studio) {
        return studio.id;
      })) !== (0, _stringify2.default)(props.studiosData.map(function (studio) {
        return studio.id;
      }))) {
        return true;
      }

      if (!defaultLocation && props.defaultLocation) {
        return true;
      } else if ((0, _stringify2.default)(defaultLocation) !== (0, _stringify2.default)(props.defaultLocation)) {
        return true;
      }

      if (!defaultBounds && props.defaultBounds) {
        return true;
      } else if ((0, _stringify2.default)(defaultBounds) !== (0, _stringify2.default)(props.defaultBounds)) {
        return true;
      }

      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          clusterOptions = _props2.clusterOptions,
          defaultBounds = _props2.defaultBounds,
          defaultLocation = _props2.defaultLocation,
          mapRef = _props2.mapRef,
          onMarkerMouseIn = _props2.onMarkerMouseIn,
          onMarkerMouseOut = _props2.onMarkerMouseOut,
          onMarkerSelected = _props2.onMarkerSelected,
          onDragEnd = _props2.onDragEnd,
          onZoomEnd = _props2.onZoomEnd,
          studiosData = _props2.studiosData,
          children = _props2.children,
          zoom = _props2.zoom,
          style = _props2.style;


      var studios = studiosData || [];

      return _react2.default.createElement(
        Leaflet.Map,
        (0, _extends3.default)({
          style: style,
          ref: mapRef,
          maxZoom: DEFAULT_TILE_LAYER_MAX_ZOOM,
          minZoom: DEFAULT_TILE_LAYER_MIN_ZOOM,
          scrollWheelZoom: false
        }, defaultLocation && !defaultBounds ? {
          center: [defaultLocation.lat, defaultLocation.lon],
          zoom: defaultLocation.zoomLevel
        } : {}, defaultBounds ? { bounds: defaultBounds, zoom: zoom || 10 } : {}, {
          onZoomEnd: onZoomEnd,
          onDragEnd: onDragEnd,
          attributionControl: false
        }),
        _react2.default.createElement(Leaflet.TileLayer, { url: MapUnwrapped.mapTileUrl() }),
        studios.length && _react2.default.createElement(_StudioMarkerCluster.StudioMarkerCluster, {
          studios: studios,
          clusterOptions: clusterOptions,
          onMarkerSelected: onMarkerSelected,
          onMarkerMouseIn: onMarkerMouseIn,
          onMarkerMouseOut: onMarkerMouseOut
        }),
        children
      );
    }
  }], [{
    key: 'mapTileUrl',
    value: function mapTileUrl() {
      return 'https://a.tiles.mapbox.com/v3/' + (0, _universalConfig2.default)().mapbox.mapId + '/{z}/{x}/{y}.png?access_token=' + (0, _universalConfig2.default)().mapbox.apiKey;
    }
  }]);
  return MapUnwrapped;
}(_react.Component);

MapUnwrapped.propTypes = {
  defaultLocation: _propTypes2.default.shape({
    lat: _propTypes2.default.number.isRequired,
    lon: _propTypes2.default.number.isRequired,
    zoomLevel: _propTypes2.default.number.isRequired
  }),
  defaultBounds: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  style: _propTypes2.default.object,

  studiosData: _propTypes2.default.array,
  clusterOptions: _propTypes2.default.object,
  mapRef: _propTypes2.default.object,

  getLeafletRef: _propTypes2.default.func,
  onMarkerSelected: _propTypes2.default.func,
  onMarkerMouseIn: _propTypes2.default.func,
  onMarkerMouseOut: _propTypes2.default.func,
  onDragEnd: _propTypes2.default.func,
  onZoomEnd: _propTypes2.default.func,
  children: _propTypes2.default.node,
  zoom: _propTypes2.default.number
};

var Map = _react2.default.forwardRef(function (props, ref) {
  return _react2.default.createElement(MapUnwrapped, (0, _extends3.default)({}, props, { mapRef: ref }));
});
Map.displayName = 'Map';

exports.Map = Map;
exports.MapUnwrapped = MapUnwrapped;